export function generateShareURL(props: { ArtworkID: string; lang?: string }) {
  const u = new URL(
    process.env.VUE_APP_SERVERLESS_BASE_URL + `/share/${props.ArtworkID}`
  );
  if (props.lang) u.searchParams.set("lang", props.lang);
  return u.toString();
}
